export const MANAGER_ROLES = ["admin", "company_owner", "company_admin"];

export const ROLE_OPTIONS = [
  { id: "member", label: "일반 직원" },
  { id: "staff", label: "투비 임직원" },
  { id: "company_admin", label: "협력사 관리자" },
  { id: "company_owner", label: "협력사 대표" },
  { id: "admin", label: "최고 관리자" },
];

export const getRoleLabel = (role, fallback = "USER") => ({
  admin: "최고 관리자",
  company_owner: "협력사 대표",
  company_admin: "협력사 관리자",
  staff: "투비 임직원",
  member: "일반 직원",
}[role] || fallback);

export const canManageUsers = (role) => MANAGER_ROLES.includes(role);

export const visibleRoleOptions = (isSuperAdmin, currentRole = "") => {
  if (isSuperAdmin) return ROLE_OPTIONS;
  if (currentRole === "company_owner") {
    return ROLE_OPTIONS.filter((role) => ["member", "company_admin"].includes(role.id));
  }
  return ROLE_OPTIONS.filter((role) => role.id === "member");
};
